/*
创建者 魏强(2018.2.1)
金牌网店 列表
*/
<template>
  <div class="home-module mb">
    <h3 class="module-title"><span>金牌网店</span></h3>
    <div class="perStore clearfix" id="gtwdDiv">
      <div v-for="store in list" class="perStore-item" :key="store.storeId">
        <router-link
          class="brand-img"
          :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank">
          <img :src="store.storeBanner" class="scrollLoading"/>
        </router-link>

        <div class="perStore-info">
            	<span class="brand-name">
            		<router-link
                  :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}" target="_blank">
					    {{store.storeName}}
					</router-link>
            	</span>
          <p class="brand-time">好评率：{{store.praiseRate*100}}%</p>
        </div>
        <a href="javascript:void(0);" onclick="" class="perStore-favorite">收藏本店</a>
        <!-- 金牌个体 -->
        <span v-if="store.personalStoreType == '3000'" class="jpStore"></span>
      </div>
    </div>
    <div id="gtwdDivLoadding" v-if="loading">正在加载，请稍候 ...</div>
    <Alert v-if="!hasMore">没有更多数据</Alert>
  </div>
</template>
<script>
  import {personalStoreListPage} from 'api/home';

  export default{
    props: ["data"],
    data(){
      return {
        list: this.data,
        pageNo: 2,
        pageSize: 8,
        hasMore: true,
        loading: false,
        hasBoundScroll: false
      };
    },
    created(){
      this.bindScroll();
    },
    destroyed(){
      $(window).unbind("scroll");
    },
    activated(){
      this.bindScroll();
    },
    deactivated(){
      $(window).unbind("scroll");
      this.hasBoundScroll = false;
    },
    methods: {
      fetchData(){
        if (this.hasMore && !this.loading) {
          this.loading = true;
          personalStoreListPage(this.pageNo, this.pageSize).then(json => {
            if (json.resCode == 1) {
              this.loading = false;
              let data = json.data;
              this.hasMore = data.hasMore;
              if (this.hasMore) {
                this.pageNo = this.pageNo + 1;
              }
              let storeList = data.list || [];
              let temp = this.list;
              this.list = temp.concat(storeList);
            }
          });
        }
      },
      bindScroll(){
        //防止重复绑定
        let _this = this;
        if(!this.hasBoundScroll){
          $(window).scroll(function(e){
            var scrollTop = $(this).scrollTop();
            var scrollHeight = $(document).height();
            var windowHeight = $(window).height();
            if(scrollTop + windowHeight+430 >= scrollHeight && _this.hasMore && !_this.loading ){
              _this.fetchData();
            }
          });
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// store-list.vue?55ee8277